import { Box, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import useAppStore from "store/app"
import useAlertStore from "store/alert"

import Layout from "./Layout"
import SecondaryButton from "../../shared/buttons/SecondaryButton"
import Email from "../../shared/fields/Email"
import Password from "../../shared/fields/Password"
import ForgotPassword from "./links/ForgotPassword"
import SignInLink from "./links/SignIn"
import BackButton from "components/shared/buttons/BackButton"
import { useEffect } from "react"
import useTranslation from "hooks/use_translation"

const Login = () => {
  const login = useAppStore((state) => state.login)
  const emailField = useAppStore((state) => state.fields.email)
  const passwordField = useAppStore((state) => state.fields.password)
  const showAlert = useAlertStore((state) => state.showAlert)
  // const syncClient = useAppStore((state) => state.syncClient)
  const resetFields = useAppStore((state) => state.resetFields)

  const { pages } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    resetFields()
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault()

    const params = {
      email: emailField.input_value,
      password: passwordField.input_value,
    }

    login(params)
      .then((response) => {
        localStorage.setItem("token", response.data.access_token)
        navigate("/me")
      })
      .catch((error) => showAlert(error?.response?.data?.error_messages, "error"))
  }

  return (
    <Layout>
      <BackButton />
      <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>
        {pages?.login_page?.title}
      </Typography>
      <Typography variant="body1">{pages?.login_page?.description}</Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Email />
        <Password />
        <ForgotPassword />
        <SecondaryButton text={pages?.home?.login} fullWidth type="submit" />
      </Box>

      <SignInLink />
    </Layout>
  )
}

export default Login
